import { Component, PLATFORM_ID, Inject, ViewChild, OnInit, HostListener, ChangeDetectorRef, ElementRef } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
declare var $: any;
declare var FB: any;
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { GridStack, GridStackNode } from 'gridstack';
import { ProductDialogResComponent } from './modal/product-dialog-res/product-dialog-res.component';
import html2canvas from 'html2canvas';
import { HeaderComponent } from 'src/app/shared/header/header.component';
import { PwaService } from 'src/app/shared/services/pwa.service';
import { AppTourService } from 'src/app/shared/services/app-tour.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { HttpHeaders } from '@angular/common/http';
import { Location } from '@angular/common';
declare var intlTelInput: any;  // Declare intlTelInpu
import { getMessaging } from "firebase/messaging";
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { NotificationPermissionService } from 'src/app/shared/services/notification-permission.service';
import { ComponentService } from '../component.service';

@Component({
  selector: 'app-store-restaurant',
  templateUrl: './store-restaurant.component.html',
  styleUrl: './store-restaurant.component.scss'
})
export class StoreRestaurantComponent implements OnInit {
  @ViewChild(HeaderComponent, { static: false }) headerComponent: HeaderComponent;
  coupons_list: any = []
  PositionValue = 'sticky'
  marginTopValue = '150px'
  name = 'Jquery Integration With Angular!';
  layout_cat: any = [];
  layout_main_cat: any = [];
  isJqueryWorking: any;
  store_name_slug: any;
  categories_list: any = [];
  branch_list: any = [];
  store_data: any;
  current_store_uid: any;
  current_layout_data: any;
  iframe_src: any;
  isDisplay = false;
  textColor = 'white';
  isPreview = ''
  display_social_icons = { "facebook": false, "instagram": false, "twitter": false, "youtube": false }
  serializedRestaurantData = []
  serializedIds = []
  grid: any
  cartItem = []
  cart_ids = []
  selectedProdct = []
  selected_cart_items = []
  isAllSelected = false
  show_add_item = false
  all_items = []
  filtered_items = []
  no_content_display = false
  current_list_id = ''
  current_list_data: any = {}
  counter_img = ''
  show_loader = false
  is_list_view = false
  display_print_content = false
  qr_elementType: 'url' | 'canvas' | 'img' = 'url';
  qr_value = ''
  store_id: any;
  showHelpIcon: boolean = false;
  store_category: any;
  store_main_category: any;
  selectedMainCategory: any;
  printCart = false;
  store_logo: any;
  old_localstorage_last_publish_date: any;
  old_localstorage_uid: any;
  layout_change: any;
  circular_update_flag: any = false;
  circular_update_flag_inside: any = false;
  store_item: any;
  past_item: any;

  emailForm = this.formBuilder.group({
    email: ''
  });
  layout_data: any;
  show_dynamic_header: any = '';
  show_loader1: boolean;
  pro_dailog: boolean;
  list: any;
  packName: any;
  categoryLoad: boolean;
  packDetails: any[];
  matching_items: any;
  currentListData: any;
  createdCart: boolean;
  private myVideoPlayer: any;
  cateGoryLoad: boolean;
  displayRestaurantPage: boolean;
  current_bundle_data: any;
  current_circular_data: any;
  serializedBundleData: any = [];
  serializedMenuData: any = [];
  serializedCommunityData: any = [];
  serializedData: any = [];
  combinedData: any = [];
  current_menu_data: any;
  current_community_data: any;
  loadPage: string;
  totalAmount: any = 0;
  Amount: any;
  isLoading: boolean;
  isCardValid: boolean;
  checkoutForm!: FormGroup;
  apiUrl = 'https://api.clover.com/invoicingcheckoutservice/v1/checkouts';
  privateKey: any = '';
  firstName: any;
  lastName: any;
  email: any;
  phone: any;
  separateDialCode = false;
  merchantId: any = '';
  message: any;
  LoggedIn: string = 'no';
  private authSubscription: Subscription;
  isSubscribed: boolean = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  windowResize: boolean = false;
  options: any;
  featureRowArray: any = [];
  qr_value_main: string = '';
  showMenuTemplate: boolean = true;
  @ViewChild('menuIframe', { static: false }) menuIframe!: ElementRef;
  constructor(@Inject(PLATFORM_ID)
  private platformId: object,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    private afStorage: AngularFireStorage,
    private modalService: NgbModal,
    private storage: AngularFireStorage,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private fns: AngularFireFunctions,
    private pwaService: PwaService,
    private apptourService: AppTourService,
    private notificationPermission: NotificationPermissionService,
    private analytics: AngularFireAnalytics,
    private location: Location,
    private fb: FormBuilder,
    private componentService: ComponentService,
    @Inject(DOCUMENT) private document,
  ) {
    this.checkoutForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
    });
  }

  // code for swipe left event (open shopping list)
  private startX: number;
  private startY: number;
  countLeft: number = 0;
  private subscriptions: Subscription[] = [];

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onTouchMove(event: MouseEvent | TouchEvent) {
    if (document.documentElement.clientWidth <= 767) {
      if (this.startX === null || this.startY === null) {
        return;
      }
      const currentX = this.getCurrentX(event);
      const currentY = this.getCurrentY(event);
      const deltaX = currentX - this.startX;
      const deltaY = currentY - this.startY;
      if (Math.abs(deltaX) > 40) {
        const directionX = deltaX > 0 ? 'right' : 'left';
        if (directionX == 'left') {
          this.countLeft = this.countLeft + 1;
        }
        if (this.countLeft > 20) {
          // this.ShowShoppingList()
          this.countLeft = 0;
        }
      }
    }
  }

  zoomOutMobile() {
    var viewport = document.querySelector('meta[name="viewport"]');

    if (viewport) {
      viewport.setAttribute('content', 'initial-scale=0.7, width=280,user-scalable=no,minimum-scale=-9, maximum-scale=1.0');

    }
  }
  zoomOutMobile1() {
    var viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'initial-scale=0.5, width=280,user-scalable=no,minimum-scale=-9, maximum-scale=1.0');

    }
  }

  onTouchStart(event: MouseEvent | TouchEvent) {
    this.startX = this.getCurrentX(event);
    this.startY = this.getCurrentY(event);
    this.countLeft = 0;
  }

  onTouchEnd(event: MouseEvent | TouchEvent) {
    this.startX = null;
    this.startY = null;
  }

  private getCurrentX(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.clientX;
    } else if (event instanceof TouchEvent) {
      return event.touches[0].clientX;
    }

    return 0;
  }

  private getCurrentY(event: MouseEvent | TouchEvent): number {
    if (event instanceof MouseEvent) {
      return event.clientY;
    } else if (event instanceof TouchEvent) {
      return event.touches[0].clientY;
    }

    return 0;
  }

  isPWAInstalled() {
    return (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone) || document.referrer.includes('android-app://');
  }
  async openNotification() {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        alert("Notifications are already enabled!");
      } else if (Notification.permission === "denied") {
        if (this.isPWAInstalled()) {
          // If PWA is installed, guide the user to enable notifications via system settings
          alert("Press and hold the app icon and select settings. Then allow notifications. ");
        } else {
          // If PWA is not installed, guide the user to enable via browser settings
          alert("Notifications are blocked. To enable them, click the icon next to the URL in the address bar and allow notifications.");
        }
      } else {
        Notification.requestPermission().then(async (permission) => {
          if (permission === "granted") {
            alert("Notifications enabled!");
            const registration = await navigator.serviceWorker.ready;
            console.log('Service Worker ready:');

            const messaging = getMessaging();
            this.notificationPermission.listenForForegroundMessages(messaging);

            const currentToken = await this.notificationPermission.generateToken(messaging, registration);
            if (!currentToken) return;
            this.authSubscription = await this.afAuth.authState.subscribe(async user => {
              if (!this.isSubscribed) return; // Prevent execution if unsubscribed
              if (user) {
                this.LoggedIn = 'yes'
              } else {
                this.LoggedIn = 'no'
              }
              this.subscriptions[this.subscriptions.length] = await this.afs.collection('/stores', ref => ref.where('uid', '==', this.current_store_uid)).snapshotChanges().subscribe((data: any) => {
                const storeData = data.map(e => {
                  return {
                    uid: e.payload.doc.id,
                    access_coupon: e.payload.doc.data().access_coupon,
                    access_layout: e.payload.doc.data().access_layout,
                    access_recipe: e.payload.doc.data().access_recipe,
                    company_name_slug: e.payload.doc.data().company_name_slug,
                    company_name: e.payload.doc.data().company_name,
                    branch_name_slug: e.payload.doc.data().branch_name_slug,
                  };
                });
                this.notificationPermission.handleTokenStorage(this.store_data[0].company_name, storeData[0].uid, this.LoggedIn, currentToken);
              });
            });
          } else {
            alert("Notifications denied.");
          }
        });
      }
    } else {
      alert("Your browser does not support notifications.");
    }
  }





  async ngOnDestroy() {
    this.isSubscribed = false; // Mark as unsubscribed
    if (this.authSubscription) {
      await this.authSubscription.unsubscribe();
    }
    this.subscriptions.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
  onResize() {
    this.windowResize = true;
    this.loadCircularGrid(this.cart_ids)
  }
  private handleIframeMessage(event: MessageEvent) {
    const data = event.data;

    if (data && typeof data === 'object') {
      switch (data.type) {
        case 'SHOW_LOADER':
          this.show_loader1 = true;
          break;

        case 'HIDE_LOADER':
          this.show_loader1 = false;
          break;
      }
    }
  }
  async ngOnInit() {
    (window as any).openNotification = this.openNotification.bind(this);
    window.addEventListener('message', this.handleIframeMessage.bind(this));
    (window as any).editMode = false;
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(registration => {
          console.log('Service Worker registered with scope');
        })
        .catch(err => {
          console.error('Service Worker registration failed:', err);
        });
    }
    localStorage.setItem('loadPage', 'circular');
    const sessionId = localStorage.getItem('checkoutSessionIdForDisply');
    if (sessionId && sessionId !== '""') {
      console.log("id")
    } else {
      localStorage.setItem('checkoutSessionIdForDisply', JSON.stringify(''));
    }
    if (window.innerWidth >= 768) {
      localStorage.setItem("view", "normalView")
    }
    if (window.innerWidth <= 280 && window.innerWidth >= 200) {
      this.zoomOutMobile()
    }
    if (window.innerWidth <= 199) {
      this.zoomOutMobile1()
    }
    if (localStorage.getItem('showAppList') == 'true') {
      if (window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] || document.referrer.includes('android-app://')) {
        window.location.href = localStorage.getItem('appRedirectUrl');
        localStorage.setItem('showAppList', 'false');
        localStorage.removeItem('appRedirectUrl');
      } else {
      }
    } else {
      if (!(window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] || document.referrer.includes('android-app://'))) {
        this.route.data.subscribe(data => {
          if (data.showAppList === true) {
            localStorage.setItem('showAppList', 'true');
            localStorage.setItem('appRedirectUrl', window.location.href);
          } else {
            localStorage.setItem('showAppList', 'false');
            localStorage.removeItem('appRedirectUrl');
          }
        })
      }
    }

    if (this.route.snapshot.params?.list_id) {
      this.current_list_id = this.route.snapshot.params?.list_id
      this.is_list_view = true
    } else {
      if (localStorage.getItem('list_ids')) {
        const list_ids = JSON.parse(localStorage.getItem('list_ids'))
        if (list_ids.hasOwnProperty(this.route.snapshot.params.store_name)) {
          const value = list_ids[this.route.snapshot.params.store_name];
          localStorage.setItem('list_id', value)
          this.current_list_id = value
        } else {
          localStorage.removeItem('list_id')
          this.current_list_id = ''
        }
      } else {
        this.current_list_id = localStorage.getItem('list_id') ? localStorage.getItem('list_id') : ''
      }
    }

    const params = new URLSearchParams(window.location.search)
    if (params.has('payment') && params.get('payment') === 'success') {
      const sessionId = localStorage.getItem('checkoutSessionIdForDisply');
      if (sessionId && sessionId !== '""') {
        $('#orderSuccessModal').modal('show');
        localStorage.setItem('checkoutSessionIdForDisply', JSON.stringify(''));
      } else {
        this.location.replaceState(this.router.url.split('?')[0]);
      }
    }
    if (params.has('payment') && params.get('payment') === 'failure') {
      const sessionId = localStorage.getItem('checkoutSessionIdForDisply');
      if (sessionId && sessionId !== '""') {
        $('#paymentFailedModal').modal('show');
        localStorage.setItem('checkoutSessionIdForDisply', JSON.stringify(''));
      }
      setTimeout(() => {
        const closeModel = document.getElementById('faildCloseModel');
        if (closeModel) {
          closeModel.click()
        }
      }, 1000);
      this.location.replaceState(this.router.url.split('?')[0]);
    }
    if (params.has('payment') && params.get('payment') === 'cancel') {
      const sessionId = localStorage.getItem('checkoutSessionIdForDisply');
      if (sessionId && sessionId !== '""') {
        $('#paymentCancelledModal').modal('show');
        localStorage.setItem('checkoutSessionIdForDisply', JSON.stringify(''));
      }
      setTimeout(() => {
        const closeModel = document.getElementById('cancelCloseModel');
        if (closeModel) {
          closeModel.click()
        }
      }, 1000);
      this.location.replaceState(this.router.url.split('?')[0]);
    }
    if (params.has('preview') && params.get('preview') === 'true') {
      this.isPreview = '&preview=true'
    }
    localStorage.setItem('viewMode', this.route.snapshot.params.id);
    this.store_name_slug = this.route.snapshot.params.store_name;


    $(document).ready(() => {
      const body = document.body;
      const scrollUp = "scroll-up";
      const scrollDown = "scroll-down";
      let lastScroll = 0;

      window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 200) {
          body.classList.remove(scrollUp);
          body.classList.remove(scrollDown);
          return;
        }

        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
          // down
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);

        } else if (
          currentScroll < lastScroll &&
          body.classList.contains(scrollDown)
        ) {
          // up
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);

        }
        lastScroll = currentScroll;
      });

      const LocalURL = 'http://localhost:4200';
      const FireBaseURL = 'https://digital-circular-pro-admin.web.app';
      if (document.location.href == FireBaseURL + '/home') {
        $('.circular-menu').addClass('menu-active');
      }
      if (document.location.href == FireBaseURL + '/coupon-list') {
        $('.Coupons').addClass('menu-active');
        $('.bottom-header-section').addClass('d-none');
      }
      if (document.location.href == FireBaseURL + '/recipe-list') {
        $('.Recipes').addClass('menu-active');
        $('.bottom-header-section').addClass('d-none');
      }
      if (this.router.url == '/' + this.store_name_slug) {
        $('.circular-menu').addClass('tab-high');
      }
    });
    // this.store_data = await this.afs.collection('/stores', ref => ref.where('company_name_slug', '==', this.store_name_slug)).get().toPromise()
    // .then(storeData => {
    // 	return storeData.docs.map(doc => doc.data());
    // });
    this.qr_value_main = window.location.href
    await this.afs.collection('stores', ref => ref.where('company_name_slug', '==', this.store_name_slug)).snapshotChanges().subscribe(async (data: any) => {
      this.store_data = await data.map(e => {
        return {
          uid: e.payload.doc.id,
          access_coupon: e.payload.doc.data()['access_coupon'],
          access_layout: e.payload.doc.data()['access_layout'],
          access_recipe: e.payload.doc.data()['access_recipe'],
          address: e.payload.doc.data()['address'],
          zip_code: e.payload.doc.data()['zip_code'],
          company_name_slug: e.payload.doc.data()['company_name_slug'],
          company_name: e.payload.doc.data()['company_name'],
          banner_image: e.payload.doc.data()['banner_image'],
          qr_image: e.payload.doc.data()['qr_image'],
          printHeaderOption: e.payload.doc.data()['printHeaderOption'],
          headerViewOption: e.payload.doc.data()['headerViewOption'],
          googleMeasurementId: e.payload.doc.data()['googleMeasurementId'],
          PrintBannerTitle: e.payload.doc.data()['PrintBannerTitle'],
          email: e.payload.doc.data()['email'],
          menu1_link: e.payload.doc.data()['menu1_link'] ? e.payload.doc.data()['menu1_link'] : "",
          menu1_name: e.payload.doc.data()['menu1_name'],
          menu2_name: e.payload.doc.data()['menu2_name'],
          menu2_link: e.payload.doc.data()['menu2_link'],
          menu3_name: e.payload.doc.data()['menu3_name'],
          menu3_link: e.payload.doc.data()['menu3_link'],
          menu4_name: e.payload.doc.data()['menu4_name'],
          menu4_link: e.payload.doc.data()['menu4_link'],
          menu5_name: e.payload.doc.data()['menu5_name'],
          menu5_link: e.payload.doc.data()['menu5_link'],
          menu6_name: e.payload.doc.data()['menu6_name'],
          menu6_link: e.payload.doc.data()['menu6_link'],
          menu7_name: e.payload.doc.data()['menu7_name'],
          menu7_link: e.payload.doc.data()['menu7_link'],
          menu8_name: e.payload.doc.data()['menu8_name'],
          menu8_link: e.payload.doc.data()['menu8_link'],
          menu9_name: e.payload.doc.data()['menu9_name'],
          menu9_link: e.payload.doc.data()['menu9_link'],
          parent_id: e.payload.doc.data()['parent_id'],
          type: e.payload.doc.data()['type'],
          store_logo: e.payload.doc.data()['store_logo'],
          phone: e.payload.doc.data()['phone'],
          social_facebook_url: e.payload.doc.data()['social_facebook_url'],
          social_twitter_url: e.payload.doc.data()['social_twitter_url'],
          social_instagram_url: e.payload.doc.data()['social_instagram_url'],
          social_youtube_url: e.payload.doc.data()['social_youtube_url'],
          theme_base_color: e.payload.doc.data()['theme_base_color'],
          branch_name_color: e.payload.doc.data().branch_name_color || "#666666",
          theme_text_color: e.payload.doc.data()['theme_text_color'],
          override_noad_layout: e.payload.doc.data().override_noad_layout ? e.payload.doc.data().override_noad_layout : false,
          displayCircularPage: e.payload.doc.data().displayCircularPage ? e.payload.doc.data().displayCircularPage : false,
          displayBundlePage: e.payload.doc.data().displayBundlePage ? e.payload.doc.data().displayBundlePage : false,
          displayMenuPage: e.payload.doc.data().displayMenuPage ? e.payload.doc.data().displayMenuPage : false,
          displayCouponPage: e.payload.doc.data().displayCouponPage ? e.payload.doc.data().displayCouponPage : false,
          displayRecipePage: e.payload.doc.data().displayRecipePage ? e.payload.doc.data().displayRecipePage : false,
          displayRestaurantPage: e.payload.doc.data().displayRestaurantPage ? e.payload.doc.data().displayRestaurantPage : false,
          merchantId: e.payload.doc.data().merchantId ? e.payload.doc.data().merchantId : '',
          apiToken: e.payload.doc.data().apiToken ? e.payload.doc.data().apiToken : '',
        };
      });
      this.authSubscription = await this.afAuth.authState.subscribe(async user => {
        if (!this.isSubscribed) return; // Prevent execution if unsubscribed
        if (user) {
          this.LoggedIn = 'yes'
        } else {
          this.LoggedIn = 'no'
        }
        await this.notificationPermission.requestPermission(this.store_data[0].company_name, this.store_data[0].uid, this.LoggedIn);
      });


      if (this.store_data[0]?.merchantId) {
        this.merchantId = this.store_data[0]?.merchantId
      }
      if (this.store_data[0]?.apiToken) {
        this.privateKey = this.store_data[0]?.apiToken
      }
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      // Check if app is running in standalone mode (installed)
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
      if (isStandalone) {
        if (isIOS) {
          const hasLoggedInstall = localStorage.getItem('ios_pwa_installed_logged');
          if (!hasLoggedInstall) {
            // PWA installed & launched from home screen on iOS
            this.analytics.logEvent('@pwa_installed_on_ios_count', {
              store_name: this.store_data[0]?.company_name,
              message: 'PWA installed and launched on iOS device',
            });
            if (this.store_data[0]?.googleMeasurementId) {
              (window as any).gtag('event', '@pwa_installed_on_ios_count', {
                send_to: `${this.store_data[0]?.googleMeasurementId}`,
                store_name: this.store_data[0]?.company_name,
                message: 'PWA installed and launched on iOS device',
              });
            }
            localStorage.setItem('ios_pwa_installed_logged', 'true');
          }
        }
      }
      if (this.store_data[0]?.googleMeasurementId) {
        await this.apptourService.load(this.store_data[0]?.googleMeasurementId);
        window.addEventListener('appinstalled', () => {
          (window as any).gtag('event', '@pwa_installed_on_Android&Desktop_count', {
            send_to: `${this.store_data[0]?.googleMeasurementId}`,
            store_name: this.store_data[0]?.company_name,
            message: 'PWA install successfully.',
          });
        })
      }
      if (this.store_data[0]?.displayRestaurantPage) {
        this.displayRestaurantPage = true
        if (this.store_data[0]?.company_name) {
          if (this.route.snapshot.params?.list_id) {
            if (document.title == 'Digital Circular Pro') {
              if (this.store_data[0]?.googleMeasurementId) {
                (window as any).gtag('event', 'page_view', {
                  send_to: `${this.store_data[0]?.googleMeasurementId}`,
                  page_title: `ShoppingList - ${this.store_data[0]?.company_name}`
                });
              }
            }
            document.title = `ShoppingList - ${this.store_data[0]?.company_name}`;
            this.analytics.logEvent('page_view', { page_title: `ShoppingList - ${this.store_data[0]?.company_name}` });
          } else {
            if (document.title == 'Digital Circular Pro') {
              if (this.store_data[0]?.googleMeasurementId) {
                (window as any).gtag('event', 'page_view', {
                  send_to: `${this.store_data[0]?.googleMeasurementId}`,
                  page_title: `Restaurant - ${this.store_data[0]?.company_name}`
                });
              }
            }
            document.title = `Restaurant - ${this.store_data[0]?.company_name}`;
            this.analytics.logEvent('page_view', { page_title: `Restaurant - ${this.store_data[0]?.company_name}` });
          }
        }
      } else {
        this.displayRestaurantPage = false
        this.PositionValue = 'fixed'
        if (this.store_data[0]?.displayBundlePage) {
          this.router.navigate(['/' + this.store_name_slug + '/bundles']);
        } else if (this.store_data[0]?.displayMenuPage) {
          this.router.navigate(['/' + this.store_name_slug + '/menu']);
        } else if (this.store_data[0]?.displayCouponPage) {
          this.router.navigate(['/' + this.store_name_slug + '/coupon']);
        } else if (this.store_data[0]?.displayRecipePage) {
          this.router.navigate(['/' + this.store_name_slug + '/recipes']);
        } else if (this.store_data[0]?.displayCircularPage) {
          this.router.navigate(['/' + this.store_name_slug]);
        }
      }
      this.textColor = this.store_data[0]?.theme_text_color ? this.store_data && this.store_data[0]?.theme_text_color : 'white';
      if (this.textColor === 'white' || this.textColor === '#ffffff') {
        this.counter_img = "../../../assets//imgs/white-counter.svg"
      } else {
        this.counter_img = '../../../assets//imgs/black-counter.svg'
      }
      this.isDisplay = true;
      if (this.store_data[0].social_facebook_url !== "" && this.store_data[0].social_facebook_url !== undefined) { this.display_social_icons.facebook = true }
      if (this.store_data[0].social_twitter_url !== "" && this.store_data[0].social_twitter_url !== undefined) { this.display_social_icons.twitter = true }
      if (this.store_data[0].social_instagram_url !== "" && this.store_data[0].social_instagram_url !== undefined) { this.display_social_icons.instagram = true }
      if (this.store_data[0].social_youtube_url !== "" && this.store_data[0].social_youtube_url !== undefined) { this.display_social_icons.youtube = true }

      if (this.store_data && this.store_data.length > 0) {
        this.current_store_uid = this.store_data[0]?.uid;

        const start_date = new Date();
        const params = new URLSearchParams(window.location.search)

        const store_itemData = await this.afs.collection('/store-items', ref => ref.where('store_uid', '==', this.store_data[0].uid).orderBy('created_at', 'desc')).get().toPromise();
        this.store_item = store_itemData.docs.map((e: any) => {
          return {
            upc_code: e.data()['upc_code'],
            product_description: e.data()['product_description'],
            product_name_slug: e.data().product_name_slug,
            pack: e.data()['pack'],
            price_label_format: e.data()['price_label_format'],
            price_label_value1: this.convertArrayToString(e.data()['price_label_value1'] ? e.data()['price_label_value1'] : ""),
            price_label_value2: this.convertArrayToString(e.data()['price_label_value2'] ? e.data()['price_label_value2'] : ""),
            price_label_value3: this.convertArrayToString(e.data()['price_label_value3'] ? e.data()['price_label_value3'] : ""),
            price_label_highlight: e.data()['price_label_highlight'] ? e.data()['price_label_highlight'] : "",
            product_url: e.data()['product_url'] ? e.data()['product_url'] : "",
            hide_price_label: e.data()['hide_price_label'] ? e.data()['hide_price_label'] : false,
            hide_addtolist_label: e.data()['hide_addtolist_label'] ? e.data()['hide_addtolist_label'] : false,
            hide_productname_label: e.data()['hide_productname_label'] ? e.data()['hide_productname_label'] : false,
            cost: e.data()['cost'] ? e.data()['cost'] : "",
            srp: e.data()['srp'] ? e.data()['srp'] : "",
            storeInMaster: e.data().storeInMaster ? e.data().storeInMaster : '',
            category: e.data()['category'] ? e.data()['category'] : "",
            offerLabel: e.data().offerLabel ? e.data().offerLabel : '',
            labelSide: e.data().labelSide ? e.data().labelSide : '',
            uid: e.id,
            product_image: e.data().product_image ? e.data().product_image : 'https://placehold.co/30/cecece/cecece',
            price_label_svg: e.data().price_label_svg ? e.data().price_label_svg : '',
            sale_price_label_format: e.data()['sale_price_label_format'] ? e.data()['sale_price_label_format'] : "",
            sale_price_label_value1: e.data()['sale_price_label_value1'] ? e.data()['sale_price_label_value1'] : "",
            sale_price_label_value2: e.data()['sale_price_label_value2'] ? e.data()['sale_price_label_value2'] : "",
            sale_price_label_value3: e.data()['sale_price_label_value3'] ? e.data()['sale_price_label_value3'] : "",
            final_price_label_format: e.data()['final_price_label_format'] ? e.data()['final_price_label_format'] : "",
            final_price_label_value1: e.data()['final_price_label_value1'] ? e.data()['final_price_label_value1'] : "",
            final_price_label_value2: e.data()['final_price_label_value2'] ? e.data()['final_price_label_value2'] : "",
            final_price_label_value3: e.data()['final_price_label_value3'] ? e.data()['final_price_label_value3'] : "",
            digital_coupon_price_label_format: e.data()['digital_coupon_price_label_format'] ? e.data()['digital_coupon_price_label_format'] : "",
            digital_coupon_price_label_value1: e.data()['digital_coupon_price_label_value1'] ? e.data()['digital_coupon_price_label_value1'] : "",
            digital_coupon_price_label_value2: e.data()['digital_coupon_price_label_value2'] ? e.data()['digital_coupon_price_label_value2'] : "",
            digital_coupon_price_label_value3: e.data()['digital_coupon_price_label_value3'] ? e.data()['digital_coupon_price_label_value3'] : "",
            note: e.data()['note'] ? e.data()['note'] : "",
            link: e.data()['link'] ? e.data()['link'] : "",
            usage_limit: e.data()['usage_limit'] ? e.data()['usage_limit'] : "",
            digital_coupon: e.data()['digital_coupon'] ? e.data()['digital_coupon'] : false,
            sale_price_label_svg: e.data().sale_price_label_svg ? e.data().sale_price_label_svg : '',
            sale_content_price_label_svg: e.data().sale_content_price_label_svg ? e.data().sale_content_price_label_svg : '',
            final_price_label_svg: e.data().final_price_label_svg ? e.data().final_price_label_svg : '',
            final_content_price_label_svg: e.data().final_content_price_label_svg ? e.data().final_content_price_label_svg : '',
            digital_coupon_price_label_svg: e.data().digital_coupon_price_label_svg ? e.data().digital_coupon_price_label_svg : '',
            digital_content_coupon_price_label_svg: e.data().digital_content_coupon_price_label_svg ? e.data().digital_content_coupon_price_label_svg : '',
            is_saved: e.data().is_saved ? e.data().is_saved : '',
            store_uid: e.data().store_uid ? e.data().store_uid : '',
            isVideo: e.data().isVideo ? e.data().isVideo : false,
            master_uid: e.data().master_uid ? e.data().master_uid : '',
          };
        });
        this.packDetails = store_itemData.docs.map(doc => ({
          uid: doc.id,
          pack: (doc.data() as { pack: any }).pack
        }));

        this.show_loader1 = true
        if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
          if (params.has('type') && params.get('type') === 'noad') {
            // Parallelize independent data fetching operations
            [this.current_layout_data, this.current_circular_data, this.current_bundle_data, this.current_menu_data,this.current_community_data] = await Promise.all([
              this.getLayoutPreview('/restaurant'),
              this.getCircularPreview('/layouts'),
              this.getBundlePreview("/bundles"),
              this.getMenuPreview("/menus"),
              this.getCommunityPreview("/community")
            ]);
            this.layoutData();
          } else {
            // Parallelize independent data fetching operations
            [this.current_layout_data, this.current_bundle_data, this.current_menu_data, this.current_circular_data,this.current_community_data] = await Promise.all([
              this.getLayoutPreview("/restaurant"),
              this.getBundlePreview("/bundles"),
              this.getMenuPreview("/menus"),
              this.getCircularPreview('/layouts'),
              this.getCommunityPreview("/community")
            ]);
            this.layoutData();
            this.afs.collection('/restaurant', ref => ref.where('uid', '==', this.route.snapshot.params.id)).snapshotChanges().subscribe(async (data: any) => {
              const current_layout: any = await this.getLayoutPreview("/restaurant")
              this.old_localstorage_last_publish_date = localStorage.getItem('layout_last_publish_date') ? localStorage.getItem('layout_last_publish_date') : localStorage.setItem("layout_last_publish_date", this.current_layout_data[0]?.last_publish_timestamp);
              this.old_localstorage_uid = localStorage.getItem('layout_uid') ? localStorage.getItem('layout_uid') : localStorage.setItem("layout_uid", this.current_layout_data[0]?.uid);
              if (this.old_localstorage_last_publish_date != current_layout[0]?.last_publish_timestamp && this.old_localstorage_uid == current_layout[0]?.uid && !params.has('preview')) {
                const notificationClicked = localStorage.getItem('notificationClicked')
                if (notificationClicked == 'yes') {
                  this.layout_change = false
                } else {
                  this.layout_change = true
                }
                localStorage.setItem("layout_last_publish_date", current_layout[0]?.last_publish_timestamp);
                localStorage.setItem("layout_uid", current_layout[0]?.uid)
              }
              localStorage.setItem('notificationClicked', "no");
            })
          }
        } else {
          if (!this.store_data[0].override_noad_layout) {
            // Parallelize independent data fetching operations
            [this.current_layout_data, this.current_bundle_data, this.current_menu_data,this.current_community_data, this.current_circular_data] = await Promise.all([
              this.getLayoutData(),
              this.getBundleData(),
              this.getMenuData(),
              this.getCommunityData(),
              this.getCircularData()
            ]);

            this.layoutData();
            this.afs.collection('/restaurant', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).snapshotChanges().subscribe(async (data) => {
              const current_layout: any = await this.getLayoutData()
              this.old_localstorage_last_publish_date = localStorage.getItem('layout_last_publish_date') ? localStorage.getItem('layout_last_publish_date') : localStorage.setItem("layout_last_publish_date", this.current_layout_data[0]?.last_publish_timestamp);
              this.old_localstorage_uid = localStorage.getItem('layout_uid') ? localStorage.getItem('layout_uid') : localStorage.setItem("layout_uid", this.current_layout_data[0]?.uid);
              if (this.old_localstorage_last_publish_date != current_layout[0]?.last_publish_timestamp && this.old_localstorage_uid == current_layout[0]?.uid && !params.has('preview')) {
                const notificationClicked = localStorage.getItem('notificationClicked')
                if (notificationClicked == 'yes') {
                  this.layout_change = false
                } else {
                  this.layout_change = true
                }
                localStorage.setItem("layout_last_publish_date", current_layout[0]?.last_publish_timestamp);
                localStorage.setItem("layout_uid", current_layout[0]?.uid)
              }
              localStorage.setItem('notificationClicked', "no");
            })
          } else {
            // Parallelize independent data fetching operations
            const [overrideLayout, bundleData, menuData,communityData, layoutData] = await Promise.all([
              this.afs.collection('/layouts-noad', ref => ref.where('store_uid', '==', this.current_store_uid)).get().toPromise(),
              this.getBundleData(),
              this.getMenuData(),
              this.getCommunityData(),
              this.getLayoutData()
            ]);
            this.current_circular_data = overrideLayout.docs.map(doc => doc.data());
            this.current_bundle_data = bundleData;
            this.current_menu_data = menuData;
            this.current_community_data = communityData;
            this.current_layout_data = layoutData;
            if (this.current_layout_data.include_header_checkbox) {
              this.show_dynamic_header = 'show_dynamic_header';
            } else {
              this.show_dynamic_header = '';
            }

            const params = new URLSearchParams(window.location.search)
            this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json;
            this.serializedMenuData = this.current_menu_data[0]?.menu_json;
            this.serializedCommunityData = this.current_community_data[0]?.community_json;
            this.serializedBundleData = this.current_bundle_data[0]?.bundle_json;
            this.serializedData = this.current_circular_data[0]?.layout_json;
            this.combinedData = [];
            if (this.serializedRestaurantData?.length > 0) {
              this.combinedData.push(...this.serializedRestaurantData);
            }
            if (this.serializedBundleData?.length > 0) {
              this.combinedData.push(...this.serializedBundleData);
            }
            if (this.serializedMenuData?.length > 0) {
              this.combinedData.push(...this.serializedMenuData);
            }
            if (this.serializedData?.length > 0) {
              this.combinedData.push(...this.serializedData);
            }
            // this.serializedIds = this.combinedData?.map(s => s.id)
            this.serializedIds = this.combinedData?.flatMap(s => {
              if (s?.subGridOpts?.children?.length) {
                return s.subGridOpts.children.map(child => child.id);
              } else {
                return [s.id];
              }
            });
            this.store_id = this.current_layout_data[0]?.store_uid;

            if (this.current_layout_data[0]?.layout_type == 'grid') {
              this.iframe_src = this.sanitizer.bypassSecurityTrustResourceUrl('assets/dclive.html?store_uid=' + this.current_store_uid + '&template_id=' + this.current_layout_data[0]?.uid + '&r=11' + this.isPreview);
            } else {
              this.iframe_src = '';
            }

            this.layoutData()

            this.afs.collection('/layouts-noad', ref => ref.where('store_uid', '==', this.current_store_uid)).snapshotChanges().subscribe(async (data: any) => {
              const current_layout: any = await this.getLayoutData()
              this.old_localstorage_last_publish_date = localStorage.getItem('layout_last_publish_date') ? localStorage.getItem('layout_last_publish_date') : localStorage.setItem("layout_last_publish_date", this.current_layout_data[0]?.last_publish_timestamp);
              this.old_localstorage_uid = localStorage.getItem('layout_uid') ? localStorage.getItem('layout_uid') : localStorage.setItem("layout_uid", this.current_layout_data[0]?.uid);
              if (this.old_localstorage_last_publish_date != current_layout[0]?.last_publish_timestamp && this.old_localstorage_uid == current_layout[0]?.uid && !params.has('preview')) {
                const notificationClicked = localStorage.getItem('notificationClicked')
                if (notificationClicked == 'yes') {
                  this.layout_change = false
                } else {
                  this.layout_change = true
                }
                localStorage.setItem("layout_last_publish_date", current_layout[0]?.last_publish_timestamp);
                localStorage.setItem("layout_uid", current_layout[0]?.uid)
              }
              localStorage.setItem('notificationClicked', "no");
            });
          }
        }
      }

      // Parallelize independent data loading operations for initial load
      const [categoriesData, initialListData, couponsData] = await Promise.all([
        this.afs.collection('/lookup-categories').snapshotChanges().pipe(take(1)).toPromise().catch(() => null),
        this.current_list_id !== ''
          ? this.afs.collection('/list', ref => ref.where('uid', '==', this.current_list_id)).snapshotChanges().pipe(take(1)).toPromise().catch(() => null)
          : Promise.resolve(null),
        this.componentService.getValidCoupons(this.current_store_uid).pipe(take(1)).toPromise().catch(() => null)
      ]);

      // Process categories data
      if (categoriesData) {
        this.categories_list = categoriesData.map((e: any) => ({
          uid: e.payload.doc.id,
          value: e.payload.doc.data().value,
        }));
      }

      // Set up subscription for real-time categories updates
      this.afs.collection('/lookup-categories').snapshotChanges().subscribe((data: any) => {
        this.categories_list = data.map(e => ({
          uid: e.payload.doc.id,
          value: e.payload.doc.data().value,
        }));
      });

      // Process initial list data and set up subscription for real-time updates
      if (this.current_list_id !== '') {
        this.qr_value = window.location.href + '/list/' + this.current_list_id;

        // Process initial data if available
        if (initialListData) {
          this.current_list_data = initialListData.map((e: any) => ({
            uid: e.payload.doc.id,
            items: e.payload.doc.data().items,
            past_items: e.payload.doc.data().past_items,
          }));
          this.current_list_data = this.current_list_data[0];
          this.cartItem = this.current_list_data?.items;
          this.updateTotalAmount();
          this.past_item = this.current_list_data?.past_items;
          this.cart_ids = [];
          this.current_list_data?.items.forEach(i => {
            if (i?.product?.id) {
              this.cart_ids.push(i.product.id);
            } else {
              this.cart_ids.push(i.product.uid);
            }
          });
        }

        // Set up subscription for real-time list updates
        this.afs.collection('/list', ref => ref.where('uid', '==', this.current_list_id)).snapshotChanges().subscribe((data: any) => {
          this.current_list_data = data.map(e => ({
            uid: e.payload.doc.id,
            items: e.payload.doc.data().items,
            past_items: e.payload.doc.data().past_items,
          }));
          this.current_list_data = this.current_list_data[0];
          this.cartItem = this.current_list_data?.items;
          this.updateTotalAmount();
          this.past_item = this.current_list_data?.past_items;
          this.cart_ids = [];
          this.current_list_data?.items.forEach(i => {
            if (i?.product?.id) {
              this.cart_ids.push(i.product.id);
            } else {
              this.cart_ids.push(i.product.uid);
            }
          });
        });
      }

      // Process coupons data
      if (couponsData) {
        this.coupons_list = couponsData;
      }

      // Set up subscription for real-time coupons updates
      this.componentService.getValidCoupons(this.current_store_uid).subscribe((data) => {
        this.coupons_list = data;
      });
    });
  }
  resizeGrid(i) {
    this.grid.column(i);
    this.grid.compact();
  }

  // Helper method to convert array to string
  private convertArrayToString(value: any): string {
    return Array.isArray(value) ? value.join('') : value;
  }

  // Helper method to calculate total amount
  private calculateTotalAmount(): number {
    return this.cartItem.reduce((total, item) => {
      const amount = parseFloat(item.Amount) * item.count;
      return total + amount;
    }, 0);
  }

  // Helper method to update total amount
  private updateTotalAmount(): void {
    this.totalAmount = this.calculateTotalAmount();
  }

  async getLayoutData() {
    const start_date = new Date();
    const layout_data = await this.afs.collection('/restaurant', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

    const layouts = layout_data.docs.map(doc => doc.data());

    const current_layout = layouts.filter((docs: any) => {
      if (docs.include_header_checkbox) {
        this.show_dynamic_header = 'show_dynamic_header';
      } else {
        this.show_dynamic_header = '';
      }

      const layout_start_date = docs.start_date.toDate();
      const endDate = docs.end_date.toDate();

      return layout_start_date <= start_date && endDate > start_date;
    });
    return layouts;
  }
  async getCircularData() {
    const start_date = new Date();
    const layout_data = await this.afs.collection('/layouts', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

    const layouts = layout_data.docs.map(doc => doc.data());

    const current_layout = layouts.filter((docs: any) => {
      if (docs.include_header_checkbox) {
        this.show_dynamic_header = 'show_dynamic_header';
      } else {
        this.show_dynamic_header = '';
      }

      const layout_start_date = docs.start_date.toDate();
      const endDate = docs.end_date.toDate();

      return layout_start_date <= start_date && endDate > start_date;
    });
    return current_layout;
  }
  async getBundleData() {
    const start_date = new Date();
    const layout_data = await this.afs.collection('/bundles', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

    const layouts = layout_data.docs.map(doc => doc.data());

    const current_layout = layouts.filter((docs: any) => {
      if (docs.include_header_checkbox) {
        this.show_dynamic_header = 'show_dynamic_header';
      } else {
        this.show_dynamic_header = '';
      }
    });
    return layouts;
  }
  	async getCommunityData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/community', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts: any = layout_data.docs.map(doc => doc.data());
		const current_layout: any = layouts.filter((docs: any) => {
			if (docs.include_header_checkbox) {
				this.show_dynamic_header = 'show_dynamic_header';
			} else {
				this.show_dynamic_header = '';
			}
		});
		return layouts;
	}
  async getMenuData() {
    const start_date = new Date();
    const layout_data = await this.afs.collection('/menus', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

    const layouts = layout_data.docs.map(doc => doc.data());

    const current_layout = layouts.filter((docs: any) => {
      if (docs.include_header_checkbox) {
        this.show_dynamic_header = 'show_dynamic_header';
      } else {
        this.show_dynamic_header = '';
      }
    });
    return layouts;
  }
  async getLayoutPreview(data) {
    if (data == '/restaurant' && this.route.snapshot.params.id == 'upcoming') {
      const current_date = new Date();
      const noadLayout = await this.afs.collection('/restaurant', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

      const current_layout_data = noadLayout.docs.map((doc: any) => {
        const startDate = doc.data().start_date.toDate();
        if (startDate > current_date) {
          return doc.data();
        }
        return null; // or any appropriate placeholder for excluded data
      }).filter(data => data !== null);
      return current_layout_data
    } else {
      const noadLayout = await this.afs.collection(`${data}`, ref => ref.where('uid', '==', this.route.snapshot.params.id)).get().toPromise()
      const current_layout_data = noadLayout.docs.map(doc => doc.data());
      return current_layout_data
    }
  }
  async getBundlePreview(data) {
    if (data == '/bundles' && this.route.snapshot.params.id == 'upcoming') {
      const current_date = new Date();
      const noadLayout = await this.afs.collection('/bundles', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

      const current_layout_data = noadLayout.docs.map((doc: any) => {
        const startDate = doc.data().start_date.toDate();
        // if (startDate > current_date) {
        return doc.data();
        // }
        // return null; // or any appropriate placeholder for excluded data
      }).filter(data => data !== null);
      return current_layout_data
    } else {
      const noadLayout = await this.afs.collection(`${data}`, ref => ref.where('uid', '==', this.route.snapshot.params.id)).get().toPromise()
      const current_layout_data = noadLayout.docs.map(doc => doc.data());
      return current_layout_data
    }
  }
  async getCircularPreview(data) {
    if (data == '/layouts' && this.route.snapshot.params.id == 'upcoming') {
      const current_date = new Date();
      const noadLayout = await this.afs.collection('/layouts', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

      const current_layout_data = noadLayout.docs.map((doc: any) => {
        const startDate = doc.data().start_date.toDate();
        if (startDate > current_date) {
          return doc.data();
        }
        return null; // or any appropriate placeholder for excluded data
      }).filter(data => data !== null);
      return current_layout_data
    } else {
      const noadLayout = await this.afs.collection(`${data}`, ref => ref.where('uid', '==', this.route.snapshot.params.id)).get().toPromise()
      const current_layout_data = noadLayout.docs.map(doc => doc.data());
      return current_layout_data
    }
  }
  async getMenuPreview(data) {
    if (data == '/menus' && this.route.snapshot.params.id == 'upcoming') {
      const current_date = new Date();
      const noadLayout = await this.afs.collection('/menus', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

      const current_layout_data = noadLayout.docs.map((doc: any) => {
        const startDate = doc.data().start_date.toDate();
        // if (startDate > current_date) {
        return doc.data();
        // }
        // return null; // or any appropriate placeholder for excluded data
      }).filter(data => data !== null);
      return current_layout_data
    } else {
      const noadLayout = await this.afs.collection(`${data}`, ref => ref.where('uid', '==', this.route.snapshot.params.id)).get().toPromise()
      const current_layout_data = noadLayout.docs.map(doc => doc.data());
      return current_layout_data
    }
  }
  	async getCommunityPreview(data) {
		if (data == '/community' && this.route.snapshot.params.id == 'upcoming') {
			const current_date = new Date();
			const noadLayout = await this.afs.collection('/community', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

			const current_community_data = noadLayout.docs.map((doc: any) => {
				const startDate = doc.data().start_date.toDate();
				// if (startDate > current_date) {
				return doc.data();
				// }
				// return null; // or any appropriate placeholder for excluded data
			}).filter(data => data !== null);
			return current_community_data
		} else {
			const noadLayout = await this.afs.collection(`${data}`, ref => ref.where('uid', '==', this.route.snapshot.params.id)).get().toPromise()
			const current_community_data = noadLayout.docs.map(doc => doc.data());
			return current_community_data
		}
	}
  async layoutData() {
    if (this.current_layout_data) {
      const params = new URLSearchParams(window.location.search)
      //preview tab
      if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
        if (typeof (this.current_layout_data[0]?.restaurant_json_temp) == "string") {
          const layoutjsontemp = await this.afs.collection('restaurant-json-temp').doc(this.current_layout_data[0]?.restaurant_json_temp).get().toPromise()
          const current_layout_data: any = layoutjsontemp.data();
          this.current_layout_data[0].restaurant_json_temp = current_layout_data?.restaurant_json_temp
        }
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp;
        this.serializedMenuData = this.current_menu_data[0]?.menu_json_temp;
        this.serializedCommunityData = this.current_community_data[0]?.community_json_temp;
        this.serializedBundleData = this.current_bundle_data[0]?.bundle_json_temp;
        this.serializedData = this.current_circular_data[0]?.layout_json_temp;
        this.combinedData = []
        if (this.serializedRestaurantData?.length > 0) {
          this.combinedData.push(...this.serializedRestaurantData);
        }
        if (this.serializedBundleData?.length > 0) {
          this.combinedData.push(...this.serializedBundleData);
        }
        if (this.serializedMenuData?.length > 0) {
          this.combinedData.push(...this.serializedMenuData);
        }
        if (this.serializedData?.length > 0) {
          this.combinedData.push(...this.serializedData);
        }

        if (Array.isArray(this.current_layout_data[0]?.restaurant_json_temp)) {
          // this.current_layout_data[0]?.restaurant_json_temp.forEach(x => {
          //   if (x.category && !this.layout_cat.includes(x.category.trim())) {
          //     this.layout_cat.push(x.category.trim());
          //   }
          //   if (x.main_category && !this.layout_main_cat.includes(x.main_category.trim())) {
          //     this.layout_main_cat.push(x.main_category.trim());
          //   }
          // })
          this.current_layout_data[0]?.restaurant_json_temp.forEach(x => {
            // Check top-level category
            if (x?.category && !this.layout_cat.includes(x.category.trim())) {
              this.layout_cat.push(x.category.trim());
            }
            // Check subgrid categories
            if (x?.subGridOpts?.children?.length) {
              x.subGridOpts.children.forEach(val => {
                if (val?.category && !this.layout_cat.includes(val.category.trim())) {
                  this.layout_cat.push(val.category.trim());
                }
              });
            }
            if (x?.main_category && !this.layout_main_cat.includes(x.main_category.trim())) {
              this.layout_main_cat.push(x.main_category.trim());
            }
            // Check subgrid categories
            if (x?.subGridOpts?.children?.length) {
              x.subGridOpts.children.forEach(val => {
                if (val?.main_category && !this.layout_main_cat.includes(val.main_category.trim())) {
                  this.layout_main_cat.push(val.main_category.trim());
                }
              });
            }
          });
        }
        if (this.current_list_id !== '') {
          try {
            const currentListSnapshot = await this.afs.collection('/list').doc(this.current_list_id).get().toPromise();
            const currentListData: any = currentListSnapshot.data();

            let finalCurrentListData;
            if (currentListData?.past_items) {
              this.past_item = currentListData?.past_items;
              finalCurrentListData = [...currentListData?.items, ...currentListData?.past_items];
            } else {
              this.past_item = [];
              finalCurrentListData = currentListData?.items;
            };

            const commonItems = [];
            for (const storeItem of this.combinedData) {
              const storeItemUid = storeItem.id;
              if (storeItem?.id) {
                const isCommon = finalCurrentListData.some(cartItem => {
                  return cartItem.product.id == storeItem.id || cartItem.product.uid == storeItem.id;
                });

                if (isCommon) {
                  commonItems.push(storeItem);
                }
              }
            }
            for (const storeItem of this.store_item) {
              const storeItemUid = storeItem.id;
              if (storeItem?.uid) {
                const isCommon = finalCurrentListData.some(cartItem => {
                  return cartItem.product.uid == storeItem.uid;
                });
                if (isCommon) {
                  commonItems.push(storeItem);
                }
              }
            }
            this.cartItem = [];
            this.past_item = [];

            for (const currentCartItem of finalCurrentListData) {

              let storeItem
              if (currentCartItem.product.id) {
                storeItem = commonItems.find(item =>
                  item.id == currentCartItem.product.id);
              } else {
                storeItem = commonItems.find(item => {
                  return item.uid == currentCartItem.product.uid || item.uid == currentCartItem.product.uid
                })
              }
              if (storeItem && (
                currentCartItem?.product?.price_label_value1 !== storeItem?.price_label_value1 ||
                currentCartItem?.product?.price_label_value2 !== storeItem?.price_label_value2 ||
                currentCartItem?.product?.price_label_value3 !== storeItem?.price_label_value3 ||
                currentCartItem?.product?.sale_price_label_value1 !== storeItem?.sale_price_label_value1 ||
                currentCartItem?.product?.sale_price_label_value2 !== storeItem?.sale_price_label_value2 ||
                currentCartItem?.product?.sale_price_label_value3 !== storeItem?.sale_price_label_value3)

              ) {
                this.past_item.push(currentCartItem);
              } else {
                this.cartItem.push(currentCartItem);
              }
            }
            this.updateTotalAmount();
            await this.afs.collection('/list').doc(this.current_list_id).update({
              items: this.cartItem,
              past_items: this.past_item
            });
          } catch (error) {
            console.error("Error:", error);
          }
        }
        //store 
      } else {
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json
        this.serializedBundleData = this.current_bundle_data[0]?.bundle_json
        this.serializedMenuData = this.current_menu_data[0]?.menu_json
        this.serializedCommunityData = this.current_community_data[0]?.community_json;
        this.serializedData = this.current_circular_data[0]?.layout_json;
        this.combinedData = []
        if (this.serializedRestaurantData?.length > 0) {
          this.combinedData.push(...this.serializedRestaurantData);
        }
        if (this.serializedBundleData?.length > 0) {
          this.combinedData.push(...this.serializedBundleData);
        }
        if (this.serializedMenuData?.length > 0) {
          this.combinedData.push(...this.serializedMenuData);
        }
        if (this.serializedData?.length > 0) {
          this.combinedData.push(...this.serializedData);
        }


        this.current_layout_data[0]?.restaurant_json.forEach(x => {
          // Check top-level category
          if (x?.category && !this.layout_cat.includes(x.category.trim())) {
            this.layout_cat.push(x.category.trim());
          }
          // Check subgrid categories
          if (x?.subGridOpts?.children?.length) {
            x.subGridOpts.children.forEach(val => {
              if (val?.category && !this.layout_cat.includes(val.category.trim())) {
                this.layout_cat.push(val.category.trim());
              }
            });
          }
          if (x?.main_category && !this.layout_main_cat.includes(x.main_category.trim())) {
            this.layout_main_cat.push(x.main_category.trim());
          }
          // Check subgrid categories
          if (x?.subGridOpts?.children?.length) {
            x.subGridOpts.children.forEach(val => {
              if (val?.main_category && !this.layout_main_cat.includes(val.main_category.trim())) {
                this.layout_main_cat.push(val.main_category.trim());
              }
            });
          }
        });
        if (this.current_list_id !== '') {
          try {
            const currentListSnapshot = await this.afs.collection('/list').doc(this.current_list_id).get().toPromise();
            const currentListData: any = currentListSnapshot.data();
            let finalCurrentListData;
            if (currentListData?.past_items) {
              this.past_item = currentListData?.past_items;
              finalCurrentListData = [...currentListData?.items, ...currentListData?.past_items];
            } else {
              this.past_item = [];
              finalCurrentListData = currentListData?.items;
            };

            const commonItems = [];
            for (const storeItem of this.combinedData) {
              const storeItemUid = storeItem.id;
              if (storeItem?.id) {
                const isCommon = finalCurrentListData?.some(cartItem => {
                  return cartItem.product.id == storeItem.id || cartItem.product.uid == storeItem.id;
                });

                if (isCommon) {
                  commonItems.push(storeItem);
                }
              }
            }
            for (const storeItem of this.store_item) {
              const storeItemUid = storeItem.id;
              if (storeItem?.uid) {
                const isCommon = finalCurrentListData?.some(cartItem => {
                  return cartItem.product.uid == storeItem.uid;
                });
                if (isCommon) {
                  commonItems.push(storeItem);
                }
              }
            }
            this.cartItem = [];
            this.past_item = [];

            for (const currentCartItem of finalCurrentListData) {

              let storeItem
              if (currentCartItem.product.id) {
                storeItem = commonItems.find(item =>
                  item.id == currentCartItem.product.id);
              } else {
                storeItem = commonItems.find(item => {
                  return item.uid == currentCartItem.product.uid || item.uid == currentCartItem.product.uid
                })
              }
              if (storeItem && (
                currentCartItem?.product?.price_label_value1 !== storeItem?.price_label_value1 ||
                currentCartItem?.product?.price_label_value2 !== storeItem?.price_label_value2 ||
                currentCartItem?.product?.price_label_value3 !== storeItem?.price_label_value3 ||
                currentCartItem?.product?.sale_price_label_value1 !== storeItem?.sale_price_label_value1 ||
                currentCartItem?.product?.sale_price_label_value2 !== storeItem?.sale_price_label_value2 ||
                currentCartItem?.product?.sale_price_label_value3 !== storeItem?.sale_price_label_value3)

              ) {
                this.past_item.push(currentCartItem);
              } else {
                this.cartItem.push(currentCartItem);
              }
            }
            if (params.has('payment') && params.get('payment') === 'success') {
              this.cartItem = []
              const closeModel = document.getElementById('closeModal');
              if (closeModel) {
                closeModel.click()
              }
              this.location.replaceState(this.router.url.split('?')[0]);
            }
            if (params.has('payment') && params.get('payment') === 'failure') {
              const closeModel = document.getElementById('faildCloseModel');
              if (closeModel) {
                closeModel.click()
              }
              this.location.replaceState(this.router.url.split('?')[0]);
            }
            if (params.has('payment') && params.get('payment') === 'cancel') {
              const closeModel = document.getElementById('cancelCloseModel');
              if (closeModel) {
                closeModel.click()
              }
              this.location.replaceState(this.router.url.split('?')[0]);
            }
            this.updateTotalAmount();
            await this.afs.collection('/list').doc(this.current_list_id).update({
              items: this.cartItem,
              past_items: this.past_item
            });
          } catch (error) {
            console.error("Error:", error);
          }
        }
        if (this.current_list_id !== '') {
          // this.serializedIds = this.combinedData?.map(s => s.id)
          this.serializedIds = this.combinedData?.flatMap(s => {
            if (s?.subGridOpts?.children?.length) {
              return s.subGridOpts.children.map(child => child.id);
            } else {
              return [s.id];
            }
          });
          this.store_id = this.current_layout_data[0]?.store_uid;

          const currentListSnapshot = await this.afs.collection('/list').doc(this.current_list_id).get().toPromise();
          const currentListData: any = currentListSnapshot.data();

          if (currentListData?.items) {
            const updatedCartItems = [];
            const updatedPastItems = [];
            const CouponItems = currentListData.items.filter((a) => a.isCoupon == true)
            const RecipeItems = currentListData.items.filter((a) => a.isRecipe == true)
            const filterCartItems = currentListData.items.filter((a) => a.isRecipe != true && a.isCoupon != true);
            const filterPastItems = currentListData.past_items.filter((a) => a.isRecipe != true && a.isCoupon != true);
            updatedCartItems.push(...RecipeItems)
            CouponItems.forEach(currentCartItem => {
              if (currentCartItem.isCoupon) {
                this.coupons_list?.forEach(item => {
                  if (item?.uid == currentCartItem?.product?.uid) {
                    const validTillDate = new Date(currentCartItem.product.valid_till);
                    validTillDate.setHours(0, 0, 0, 0);
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    if (item.valid_till == 'expired' || validTillDate < currentDate) {
                      currentCartItem.product = {
                        ...currentCartItem.product,
                        isExpired: 'Yes'
                      };
                      updatedCartItems.push(currentCartItem)
                    } else {
                      currentCartItem.product = {
                        ...currentCartItem.product,
                        isExpired: 'No'
                      };
                      updatedCartItems.push(currentCartItem)
                    }
                  }
                })

              }
            })

            for (const currentCartItem of filterCartItems) {
              if (currentCartItem.product.id) {
                if (!this.serializedIds.includes(currentCartItem.product.id) && !currentCartItem.static) {
                  updatedPastItems.push(currentCartItem);
                } else {
                  updatedCartItems.push(currentCartItem);
                }
              } else {
                if (!this.serializedIds.includes(currentCartItem.product.uid) && !currentCartItem.static) {
                  updatedPastItems.push(currentCartItem);
                } else {
                  updatedCartItems.push(currentCartItem);
                }
              }
            }
            for (const currentPastItem of filterPastItems) {
              updatedPastItems.push(currentPastItem);
            }
            this.cartItem = updatedCartItems;
            this.updateTotalAmount();
            await this.afs.collection('/list').doc(this.current_list_id).update({
              items: updatedCartItems,
              past_items: updatedPastItems
            });
          }
        }
      }

      if (this.current_layout_data[0]?.layout_type == 'grid') {
        this.iframe_src = this.sanitizer.bypassSecurityTrustResourceUrl('assets/dclive.html?store_uid=' + this.current_store_uid + '&template_id=' + this.current_layout_data[0]?.uid + '&r=11' + this.isPreview);
      } else {
        this.iframe_src = '';
      }
      setTimeout(async () => {
        //   this.grid = await GridStack.init({ column: window.innerWidth < 768 ? 3 : 8, disableResize: true, disableDrag: true, removable: '#trash' });
        //   window.addEventListener("resize", () => {
        //     if (this.grid && window.innerWidth < 768) {
        //       this.resizeGrid(3);
        //     } else {
        //       this.resizeGrid(8);
        //     }
        //   })
        GridStack.renderCB = (el: HTMLElement, w: GridStackNode) => {
          if (w.content) {
            el.innerHTML = w.content;
            if (w.content == "undefined") {
              el.innerHTML = '';
            }
          }
        };
        // window.addEventListener('resize', this.onResize.bind(this));
        this.show_loader = false
        const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
        if (view != "listView") {
          // this.show_loader1 = false;
        }

        const params = new URLSearchParams(window.location.search)
        let featureRow = []
        let val
        if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
          featureRow = this.current_layout_data[0]?.restaurant_json_temp.filter(item => item?.featured_product);
        } else {
          featureRow = this.current_layout_data[0]?.restaurant_json.filter(item => item?.featured_product);
        }
        if (featureRow?.length > 0) {
          // val = 'featured'
          // this.selectedMainCategory = 'featured'
          this.featureRowArray = featureRow
        }
        val = 'All'
        this.selectedMainCategory = 'All'
        // }
        var newItem
        if (val == 'featured') {
          this.layout_cat = []
          this.store_category = []
          this.cateGoryLoad = true
        } else if (val == 'All') {
          if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
            this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp;
          } else {
            this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json;
          }
          this.cateGoryLoad = true
          this.layout_cat = []
          this.store_category = []
        } else {
          if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
            // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
            newItem = this.current_layout_data[0]?.restaurant_json_temp.flatMap(x => {
              const isParentMatch = x.category?.trim() === val;

              const matchingChildren = x.subGridOpts?.children?.filter(
                child => child.category?.trim() === val
              ) || [];

              if (isParentMatch) {
                // Return parent item as-is
                return [x];
              } else if (matchingChildren.length > 0) {
                // Return parent with filtered children
                return [{
                  ...x,
                  subGridOpts: {
                    ...x.subGridOpts,
                    children: matchingChildren
                  }
                }];
              }
              // No match — exclude this item
              return [];
            });
          } else {
            // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
            newItem = this.current_layout_data[0]?.restaurant_json.flatMap(x => {
              const isParentMatch = x.main_category?.trim() === val;

              const matchingChildren = x.subGridOpts?.children?.filter(
                child => child.main_category?.trim() === val
              ) || [];

              if (isParentMatch) {
                // Return parent item as-is
                return [x];
              } else if (matchingChildren.length > 0) {
                // Return parent with filtered children
                return [{
                  ...x,
                  subGridOpts: {
                    ...x.subGridOpts,
                    children: matchingChildren
                  }
                }];
              }
              // No match — exclude this item
              return [];
            });
          }

          this.serializedRestaurantData = newItem;
          this.layout_cat = []

          this.serializedRestaurantData.forEach(x => {
            // Check top-level category
            if (x?.category && !this.layout_cat.includes(x.category.trim())) {
              this.layout_cat.push(x.category.trim());
            }
            // Check subgrid categories
            if (x?.subGridOpts?.children?.length) {
              x.subGridOpts.children.forEach(val => {
                if (val?.category && !this.layout_cat.includes(val.category.trim())) {
                  this.layout_cat.push(val.category.trim());
                }
              });
            }
          });
          this.store_category = []
        }

        this.loadCircularGrid(this.cart_ids) // finally size to actual window
        if (this.is_list_view) {
          this.ShowShoppingList()
        }
        this.display_print_content = true
      }, 200)
      sessionStorage.setItem('is_all_clicked', 'false');
    } else {
      this.show_loader = false
      const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
      if (view != "listView") {
        // this.show_loader1 = false;
      }
    }
  }
  close_notification() {
    this.layout_change = false
  }
  showLoader(val) {
    this.show_loader = val
  }
  async categoryMainProd(val) {
    this.selectedMainCategory = val
    const params = new URLSearchParams(window.location.search)
    if (val == 'featured') {
      if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp.filter(item => item?.featured_product);
      } else {
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json.filter(item => item?.featured_product);
      }
      this.store_category = []
      this.layout_cat = []
      this.cateGoryLoad = true
      this.loadCircularGrid(this.cart_ids)
    } else if (val == 'All') {
      if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp;
      } else {
        this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json;
      }
      this.cateGoryLoad = true
      this.layout_cat = []
      this.store_category = []
      this.loadCircularGrid(this.cart_ids)
    } else {
      var newItem
      if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
        // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
        newItem = this.current_layout_data[0]?.restaurant_json_temp.flatMap(x => {
          const isParentMatch = x.main_category?.trim() === val;

          const matchingChildren = x.subGridOpts?.children?.filter(
            child => child.main_category?.trim() === val
          ) || [];

          if (isParentMatch) {
            // Return parent item as-is
            return [x];
          } else if (matchingChildren.length > 0) {
            // Return parent with filtered children
            return [{
              ...x,
              subGridOpts: {
                ...x.subGridOpts,
                children: matchingChildren
              }
            }];
          }
          // No match — exclude this item
          return [];
        });
      } else {
        // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
        newItem = this.current_layout_data[0]?.restaurant_json.flatMap(x => {
          const isParentMatch = x.main_category?.trim() === val;

          const matchingChildren = x.subGridOpts?.children?.filter(
            child => child.main_category?.trim() === val
          ) || [];

          if (isParentMatch) {
            // Return parent item as-is
            return [x];
          } else if (matchingChildren.length > 0) {
            // Return parent with filtered children
            return [{
              ...x,
              subGridOpts: {
                ...x.subGridOpts,
                children: matchingChildren
              }
            }];
          }
          // No match — exclude this item
          return [];
        });
        this.categoryLoad = true;

      }

      this.serializedRestaurantData = newItem;
      this.layout_cat = []
      this.serializedRestaurantData.forEach(x => {
        // Check top-level category
        if (x?.category && !this.layout_cat.includes(x.category.trim())) {
          this.layout_cat.push(x.category.trim());
        }
        // Check subgrid categories
        if (x?.subGridOpts?.children?.length) {
          x.subGridOpts.children.forEach(val => {
            if (val?.category && !this.layout_cat.includes(val.category.trim())) {
              this.layout_cat.push(val.category.trim());
            }
          });
        }
      });

      this.store_category = []
      this.cateGoryLoad = true
      // this.categoryProd(this.layout_cat[0])
      this.categoryProd('All')
      // this.loadCircularGrid(this.cart_ids)
      // const grid = GridStack.init({ column: window.innerWidth < 768 ? 3 : 8, disableResize: true, disableDrag: true, removable: '#trash' });
      // GridStack.renderCB = (el: HTMLElement, w: GridStackNode) => {
      //   if (w.content) {
      //     el.innerHTML = w.content;
      //     if (w.content == "undefined") {
      //       el.innerHTML = '';
      //     }
      //   }
      // };
      // grid.compact();
    }
  }
  async categoryProd(val) {
    const params = new URLSearchParams(window.location.search)
    if (val == 'All') {
      if (this.selectedMainCategory) {
        if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
          this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp.flatMap(x => {
            const isParentMatch = x.main_category?.trim() === this.selectedMainCategory;

            const matchingChildren = x.subGridOpts?.children?.filter(
              child => child.main_category?.trim() === this.selectedMainCategory
            ) || [];

            if (isParentMatch) {
              // Return parent item as-is
              return [x];
            } else if (matchingChildren.length > 0) {
              // Return parent with filtered children
              return [{
                ...x,
                subGridOpts: {
                  ...x.subGridOpts,
                  children: matchingChildren
                }
              }];
            }
            // No match — exclude this item
            return [];
          });
          // this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json_temp.filter(val=>val.main_category==this.selectedMainCategory)
        } else {
          // this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json.filter(val=>val.main_category==this.selectedMainCategory)
          this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json.flatMap(x => {
            const isParentMatch = x.main_category?.trim() === this.selectedMainCategory;

            const matchingChildren = x.subGridOpts?.children?.filter(
              child => child.main_category?.trim() === this.selectedMainCategory
            ) || [];

            if (isParentMatch) {
              // Return parent item as-is
              return [x];
            } else if (matchingChildren.length > 0) {
              // Return parent with filtered children
              return [{
                ...x,
                subGridOpts: {
                  ...x.subGridOpts,
                  children: matchingChildren
                }
              }];
            }
            // No match — exclude this item
            return [];
          });
        }

      }
      this.cateGoryLoad = true
      this.loadCircularGrid(this.cart_ids)
    }
    else {
      var newItem
      if (this.route.snapshot.params.id && params.has('preview') && params.get('preview') === 'true') {
        // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
        newItem = this.current_layout_data[0]?.restaurant_json_temp.flatMap(x => {
          const isParentMatch = x.category?.trim() === val && x.main_category?.trim() === this.selectedMainCategory;

          const matchingChildren = x.subGridOpts?.children?.filter(
            child => child.category?.trim() === val && child.main_category?.trim() === this.selectedMainCategory
          ) || [];

          if (isParentMatch) {
            // Return parent item as-is
            return [x];
          } else if (matchingChildren.length > 0) {
            // Return parent with filtered children
            return [{
              ...x,
              subGridOpts: {
                ...x.subGridOpts,
                children: matchingChildren
              }
            }];
          }
          // No match — exclude this item
          return [];
        });
      } else {
        // newItem = this.current_layout_data[0]?.layout_json.filter(x => x?.category?.trim() === val);
        newItem = this.current_layout_data[0]?.restaurant_json.flatMap(x => {
          const isParentMatch = x.category?.trim() === val && x.main_category?.trim() === this.selectedMainCategory;

          const matchingChildren = x.subGridOpts?.children?.filter(
            child => child.category?.trim() === val && child.main_category?.trim() === this.selectedMainCategory
          ) || [];

          if (isParentMatch) {
            // Return parent item as-is
            return [x];
          } else if (matchingChildren.length > 0) {
            // Return parent with filtered children
            return [{
              ...x,
              subGridOpts: {
                ...x.subGridOpts,
                children: matchingChildren
              }
            }];
          }
          // No match — exclude this item
          return [];
        });
        this.categoryLoad = true;
      }

      this.serializedRestaurantData = newItem;
      this.cateGoryLoad = true
      this.loadCircularGrid(this.cart_ids)
      const grid = GridStack.init({ column: window.innerWidth < 768 ? 3 : 8, disableResize: true, disableDrag: true, removable: '#trash' });
      GridStack.renderCB = (el: HTMLElement, w: GridStackNode) => {
        if (w.content) {
          el.innerHTML = w.content;
          if (w.content == "undefined") {
            el.innerHTML = '';
          }
        }
      };
      grid.compact();
    }
  }

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }
  initializeFB(item) {
    const initParams = {
      appId: '317808808064170',
      xfbml: true,
      version: 'v20.0'
    };
    FB.init(initParams);

    let myVideoPlayers = {};

    FB.Event.subscribe('xfbml.ready', (msg) => {
      if (msg.type === 'video' && msg.id == item.id) {
        const videoPlayer = msg.instance;
        const videoId = msg.id;

        myVideoPlayers[videoId] = videoPlayer;

        if (videoId === item.id) {
          if (item.autoplay) {
            videoPlayer.play();
          }
          videoPlayer.subscribe('finishedPlaying', () => {
            this.restartVideo(videoPlayer);
          });
        }
      }
    });

    FB.XFBML.parse();
  }

  restartVideo(videoPlayer) {
    if (videoPlayer) {
      videoPlayer.seek(0); // Seek to the beginning of the video
      videoPlayer.play(); // Play the video
    }
  }

  async loadCircularGrid(id) {
    localStorage.setItem('isFreshLoad', 'no');
    let dataForLoad = []
    let cat = [];
    if (this?.serializedRestaurantData?.length > 0) {
      localStorage.setItem("printButton", 'Display')
    } else {
      localStorage.setItem("printButton", 'NotDisplay')
    }
    this.showMenuTemplate = true
    setTimeout(() => {
      const iframe = this.menuIframe?.nativeElement;
      if (!iframe) {
        console.error('Iframe not found!');
        return;
      }

      const storeInfo = {
        storeUid: this.current_store_uid,
        editMode: false // Flag to indicate edit mode
      };
      const origin = window.origin
      iframe.src = `${origin}/assets/customize_menu.html`;
      iframe.classList.add('iframe_customize');
      iframe.onload = () => {
        // this.show_loader1=false
        iframe.contentWindow.postMessage(storeInfo, '*');
        const footerSocial1 = document.querySelector('.footer_style') as HTMLElement;
        if (footerSocial1) {
          // Get the height
          const footerHeight = footerSocial1.offsetHeight;
          // Apply margin-bottom to target element
          iframe.style.paddingBottom = footerHeight + 'px';

        }
      };
    }, 0); // waits for the DOM update


  }
  // code for CheckOut OPtion
  onCheckoutClick1() {
    this.isLoading = true
    const currentBaseUrl = window.location.origin + this.router.url;
    const customerDetails = {
      email: this.checkoutForm.value.email,
      firstName: this.checkoutForm.value.firstName,
      lastName: this.checkoutForm.value.lastName,
      phoneNumber: this.checkoutForm.value.phone.internationalNumber,
    };
    const customerDetailsLocal = {
      email: this.checkoutForm.value.email,
      firstName: this.checkoutForm.value.firstName,
      lastName: this.checkoutForm.value.lastName,
      phoneNumber: this.checkoutForm.value.phone
    };
    localStorage.setItem('customerDetails', JSON.stringify(customerDetailsLocal));
    const body = {
      customer: {
        email: this.checkoutForm.value.email,
        firstName: this.checkoutForm.value.firstName,
        lastName: this.checkoutForm.value.lastName,
        phoneNumber: this.checkoutForm.value.phone.internationalNumber,
      },
      shoppingCart: {
        lineItems: this.cartItem.map((item) => ({
          name: item.product.product_description,
          unitQty: item.count,
          price: item.Amount * 100,

        }))
      },
      successUrl: `${currentBaseUrl}/success`,
    }

    this.createCheckout(this.merchantId, this.privateKey, body).subscribe({
      next: (response: any) => {
        localStorage.setItem('checkoutSessionId', JSON.stringify(response.checkoutSessionId));
        localStorage.setItem('checkoutSessionIdForDisply', JSON.stringify(response.checkoutSessionId));
        window.location.href = response.href
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error creating checkout:', error);
      },
    });
  }
  createCheckout(merchantId: string, privateKey: string, body: any) {
    const headers = new HttpHeaders({
      'X-Clover-Merchant-Id': merchantId,
      Authorization: `Bearer ${privateKey}`,
      'Content-Type': 'application/json',
    });
    return this.http.post(this.apiUrl, body, { headers });
  }
  isFormValid(): boolean {
    return this.checkoutForm.valid;
  }
  onCheckoutClick() {
    this.resetFormFields(); // Reset the form fields
    const savedDetails = localStorage.getItem('customerDetails');
    if (savedDetails) {
      const customerDetails = JSON.parse(savedDetails);
      this.checkoutForm.patchValue({
        firstName: customerDetails.firstName || '',
        lastName: customerDetails.lastName || '',
        email: customerDetails.email || '',
        phone: customerDetails.phoneNumber || '',
      });
    }
  }

  resetFormFields() {
    this.checkoutForm.reset(); // Reset all form fields
    this.isLoading = false;

    this.updateTotalAmount();
  }
  async continue_shopping() {
    const closeModel = document.getElementById('closeModal');
    if (closeModel) {
      closeModel.click()
      this.location.replaceState(this.router.url.split('?')[0]);
    }
  }
  // end code for CheckOut Option

  getListID() {
    return localStorage.getItem('list_id')
  }
  async createCart() {
    const totalAmount = this.cartItem?.reduce((total, item) => {
      // Remove the '$' symbol and convert to a floating-point number
      const amount = parseFloat(item.Amount) * item.count;
      return total + amount;;
    }, 0); // 
    this.totalAmount = totalAmount;
    await this.afs.collection('/list').add({ items: this.cartItem }).then(docRef => {
      const itemRefx2 = this.afs.doc('/list/' + docRef.id);
      itemRefx2.update({ uid: docRef.id });
      localStorage.setItem('list_id', docRef.id)
      let list_ids;
      if (localStorage.getItem('list_ids')) {
        list_ids = JSON.parse(localStorage.getItem('list_ids'))
        list_ids[this.store_name_slug] = docRef.id;
        localStorage.setItem('list_ids', JSON.stringify(list_ids))
      } else {
        list_ids = {
          [this.store_name_slug]: docRef.id
        }
        localStorage.setItem('list_ids', JSON.stringify(list_ids))
      }
      this.current_list_id = docRef.id
      this.qr_value = window.location.href + '/list/' + this.current_list_id;
      this.show_loader = false
      // this.show_loader1 = false
    });
  }
  make_price_message(formate, value1, value2, value3) {
    if ((value1 !== null || value1 !== '') && (value2 !== null || value2 !== '')) {
      if (formate === 'format6') {
        return `Buy ${value1} Get ${value2} ${value3}`
      }
      if (formate === 'format2' || formate === 'Final Price Format1' || formate === 'Sale Price format1' || formate === 'format3' || formate === 'format4' || formate === 'format7') {
        if (value1 == '') {
          return `$0.${value2}`
        } else if (value1 && value2) {
          return `$${value1}.${value2}`
        } else if (value1 && value2 == '') {
          return `$${value1}`
        }
      }
      if (formate === 'format5' || formate === 'Sale Price format2' || formate === 'Final Price Format2') {
        if (value2 == '') {
          return `${value1} for $0.${value3}`
        } else if (value2 && value3) {
          return `${value1} for $${value2}.${value3}`
        } else if (value2 && value3 == '') {
          return `${value1} for $${value2}`
        }
      }
    }
    if (formate === 'format1' && (value1 !== null || value1 !== '')) {
      return `$${value1}`
    }
    return ''
  }

  async increase_product(i) {
    this.show_loader = true
    let temp_itm = this.cartItem[this.cartItem.indexOf(i)]
    temp_itm.count += 1
    this.cartItem[this.cartItem.indexOf(i)] = temp_itm
    this.updateTotalAmount();
    await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
    });
    this.show_loader = false
  }

  async decrease_product(i) {
    this.show_loader = true
    let temp_itm = this.cartItem[this.cartItem.indexOf(i)]
    if (temp_itm.count > 1) {
      temp_itm.count -= 1
      this.cartItem[this.cartItem.indexOf(i)] = temp_itm
    } else if (temp_itm.count === 1) {
      this.cartItem.splice(this.cartItem.indexOf(i), 1)
      if (!temp_itm.static && this.serializedIds.includes(i.product.uid)) {
        let title_bar: any = document.getElementById(i.product.uid).parentElement.childNodes[1]
        title_bar.classList.remove("test")
        this.cart_ids.splice(this.cart_ids.indexOf(i.product.uid), 1)
        document.getElementById(i.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
      }
    }
    this.updateTotalAmount();
    await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
    });
    this.show_loader = false
  }

  async remove_one_from_cart(i, type) {
    this.show_loader = true
    if (type === 'one') {
      this.cartItem.splice(this.cartItem.indexOf(i), 1)
      if (!i.static && this.serializedIds.includes(i.product.uid)) {
        let title_bar: any = document.getElementById(i.product.uid).parentElement.childNodes[1]
        title_bar.classList.remove("test")
        this.cart_ids.splice(this.cart_ids.indexOf(i.product.uid), 1)
        document.getElementById(i.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
      }
    }
    if (type == 'selected') {
      this.cartItem = this.cartItem.filter(itm => {
        if (!this.selected_cart_items.includes(itm)) {
          return true
        } else {
          this.cart_ids.splice(this.cart_ids.indexOf(i.product.uid), 1)
          if (this.serializedIds.includes(itm.product.uid)) {
            let title_bar: any = document.getElementById(itm.product.uid).parentElement.childNodes[1]
            title_bar.classList.remove("test")
            document.getElementById(itm.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
            return false
          }
        }
      })
    }
    if (type === 'all') {
      this.cartItem.forEach(itm => {
        if (!itm.static && this.serializedIds.includes(itm.product.uid)) {
          let title_bar: any = document.getElementById(itm.product.uid).parentElement.childNodes[1]
          title_bar.classList.remove("test")
          this.cart_ids.splice(this.cart_ids.indexOf(itm.product.uid), 1)
          document.getElementById(itm.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
        }
      })
      this.cartItem = []
    }
    this.updateTotalAmount();
    await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
    });
    this.show_loader = false
  }

  product_select_change(event) {
    if (event.event.target.checked && (event.event.type === 'all')) {
      this.selected_cart_items = this.cartItem
      this.isAllSelected = true
    } else if (!event.event.target.checked && (event.event.type === 'all')) {
      this.selected_cart_items = []
      this.isAllSelected = false
    } else if (event.event.target.checked && (event.event.type === 'single') && this.serializedIds.includes(event.event.product.product.uid)) {
      this.selected_cart_items.push(event.event.product)
      let title_bar: any = document.getElementById(event.event.product.product.uid).parentElement.childNodes[1]
      title_bar.classList.add("test")
      document.getElementById(event.event.product.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/right.png"
    } else if (!event.event.target.checked && (event.event.type === 'single') && this.serializedIds.includes(event.event.product.product.uid)) {
      this.selected_cart_items.splice(this.selected_cart_items.indexOf(event.event.product), 1)
      let title_bar: any = document.getElementById(event.event.product.product.uid).parentElement.childNodes[1]
      title_bar.classList.remove("test")
      this.cart_ids.splice(this.cart_ids.indexOf(event.event.product.product.uid), 1)
      document.getElementById(event.event.product.product.uid).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
    } else if (event.event.target.checked && (event.event.type === 'single') && this.serializedIds.includes(event.event.product.product.id)) {
      this.selected_cart_items.push(event.event.product)
      let title_bar: any = document.getElementById(event.event.product.product.id).parentElement.childNodes[1]
      title_bar.classList.add("test")
      document.getElementById(event.event.product.product.id).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/right.png"
    } else if (!event.event.target.checked && (event.event.type === 'single') && this.serializedIds.includes(event.event.product.product.id)) {
      this.selected_cart_items.splice(this.selected_cart_items.indexOf(event.event.product), 1)
      let title_bar: any = document.getElementById(event.event.product.product.id).parentElement.childNodes[1]
      title_bar.classList.remove("test")
      this.cart_ids.splice(this.cart_ids.indexOf(event.event.product.product.id), 1)
      document.getElementById(event.event.product.product.id).parentElement.lastElementChild.getElementsByTagName('img')[0].src = "../../../assets/imgs/plus.png"
    }
  }

  async add_to_list(item) {
    if (this.cart_ids.includes(item.uid)) {
      this._snackBar.open('Selected item is already present in your list', '', {
        duration: 2000,
      });
    } else {
      item.hide_addtolist_label = item.hide_addtolist_label ? item.hide_addtolist_label : ''
      item.price_label_value1 = item.price_label_value1 ? item.price_label_value1 : ''
      item.price_label_value2 = item.price_label_value2 ? item.price_label_value2 : ''
      item.price_label_value3 = item.price_label_value3 ? item.price_label_value3 : ''
      item.price_label_format = item.price_label_format ? item.price_label_format : ''
      item.sale_price_label_value1 = item.sale_price_label_value1 ? item.sale_price_label_value1 : ''
      item.sale_price_label_value2 = item.sale_price_label_value2 ? item.sale_price_label_value2 : ''
      item.sale_price_label_value3 = item.sale_price_label_value3 ? item.sale_price_label_value3 : ''
      item.sale_price_label_format = item.sale_price_label_format ? item.sale_price_label_format : ''

      item.product_image = item.product_image ? item.product_image : ''
      item.isVideo = item.isVideo ? item.isVideo : '',
        item.digital_coupon = item.digital_coupon ? item.digital_coupon : false;
      this.show_loader = true
      let msg
      if (item.digital_coupon) {
        msg = this.make_price_message(item?.sale_price_label_format, item?.sale_price_label_value1, item?.sale_price_label_value2, item?.sale_price_label_value3)

      } else {
        msg = this.make_price_message(item?.price_label_format, item?.price_label_value1, item?.price_label_value2, item?.price_label_value3)
      } if (document.getElementById(item.uid)) {
        let main_item = document.getElementById(item.uid)?.parentElement
        let layout_product_qnt = main_item?.parentElement?.getElementsByClassName("layout_product_qnt")[0]
        let layout_count_product: HTMLElement = main_item?.parentElement?.getElementsByClassName("layout_count_product")[0] as HTMLElement;

        let test = this.cartItem.some(x =>
          x?.product?.uid == item?.uid
        )
        if (!test) {
          this.cartItem.push({ product: item, count: 1, static: false, priceMessage: msg, digital_coupon: item.digital_coupon, isBundleProduct: item.isBundleProduct ? item.isBundleProduct : false, displayValidDate: true });
          layout_product_qnt.innerHTML = "1"
        }

        const visibility = layout_count_product?.style?.visibility
        if (item.digital_coupon) {
          layout_count_product.style.visibility = 'hidden'
        } else {
          if (visibility == "hidden" || visibility == "") {
            layout_count_product.style.visibility = 'visible'
          } else {
            layout_count_product.style.visibility = 'hidden'
          }
        }
      } else {
        this.cartItem.push({ product: item, count: 1, static: false, priceMessage: msg, digital_coupon: item.digital_coupon, isBundleProduct: item.isBundleProduct ? item.isBundleProduct : false, displayValidDate: false });
        this.cart_ids.push(item?.uid)
      }
      if (this.current_list_id !== '') {
        await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
        });
      }
      else {
        if (!this.createdCart) {
          this.createdCart = true;
          await this.createCart();
        }
      }
      this.show_loader = false
      if (this.serializedIds.includes(item.uid)) {
        let main_item
        if (document.getElementById(item.uid)) {
          if (document.getElementById(item.uid).tagName != 'VIDEO') {
            main_item = document.getElementById(item.uid)
          } else {
            main_item = document.getElementById(item.uid)?.parentElement
          }
        }
        let title_bar: any = main_item?.parentElement?.childNodes[1]
        let delete_icon = main_item?.parentElement.getElementsByClassName('deleteicon')[0]
        delete_icon.src = '../../../assets/imgs/right.png'
        title_bar.classList.add("test")
      }
      this.filtered_items = []
      this._snackBar.open('Item added in your list', '', {
        duration: 2000,
      });
    }
  }

  sendMail() {
    if (this.current_list_id) {
      const test = this.fns.httpsCallable('httpEmail')({
        to: this.emailForm.value.email,
        link: window.location.href + '/list/' + this.current_list_id
      }).toPromise()
      if (this.emailForm.value.email) {
        $("#EmailModel").modal("hide");
        this._snackBar.open('Email send successfull', '', {
          duration: 2000,
        });
        this.emailForm.reset()
      } else {
        this._snackBar.open('Please Enter Email..', '', {
          duration: 2000,
        });
      }
    };

  }

  hendle_Add_item(type) {
    if (type === 'add') {
      this.show_add_item = true
    }
    if (type === 'close') {
      this.show_add_item = false
      this.filtered_items = []
    }
  }


  async ShowShoppingList() {
    $("#ShopDropdown").animate({
      right: "0"
    });
    $('.chervon-down-icon').addClass('d-none');
    $('.chervon-up-icon').removeClass('d-none');
  }
  removeFilter() {
    this.serializedRestaurantData = this.current_layout_data[0]?.restaurant_json;
    this.loadCircularGrid(this.cart_ids)
  }
  CloseShoppingList() {
    $("#ShopDropdown").animate({
      right: "-100%"
    });
    $('.chervon-up-icon').addClass('d-none');
    $('.chervon-down-icon').removeClass('d-none');
    this.filtered_items = []
  }
  goToHome() {
    this.router.navigate(['./home']);
  }
  goToCouponPage() {
    this.router.navigate(['./coupon-list']);
  }
  goToRecipePage() {
    this.router.navigate(['./recipe-list']);
  }
  allSelection() {
    $('.all-selection-btn a').addClass('current');
    $('.coupons-only-selection-btn a').removeClass('current');
    $('.items-list').removeClass('d-none');
  }
  couponSelection() {
    $('.all-selection-btn a').removeClass('current');
    $('.coupons-only-selection-btn a').addClass('current');
    $('.items-list').addClass('d-none');
    $('.with-coupon').removeClass('d-none');
    $('.with-coupon').addClass('d-block');
  }
  bottomSliderDiv() {
    $('.slider').toggleClass('close');
  }

  copy_link() {
    var textarea = document.createElement("textarea");
    textarea.textContent = window.location.href + '/list/' + this.current_list_id;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");  // Security exception may be thrown by some browsers.
      this._snackBar.open('Link is copied to your clipboard', '', {
        duration: 2000,
      });
    }
    catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
    }
    finally {
      document.body.removeChild(textarea);
    }
  }

  async open_print() {
    this.printCart = true
    this.show_loader = true
    $('.print-head').removeClass('show-logo');
    $('body').addClass('scroll-disable');
    setTimeout(async () => {
      let element: any = document.getElementById("print-div");
      const canvas = await html2canvas(element, { useCORS: true, })
      const temp = new Promise(resolve => {
        canvas.toBlob(resolve)
      })
      await temp.then((res: any) => {
        var win = window.open(URL.createObjectURL(res));
        win.print()
        $('.print-head').addClass('show-logo');
        $('body').removeClass('scroll-disable');
        this.printCart = false
        this.show_loader = false
      })
    }, 500);
  }

  openHomePage() {
    if (this.is_list_view) {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug + '/list/' + this.current_list_id]);
    } else {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug]);
    }
  }

  openCouponsPage() {
    if (this.is_list_view) {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug + '/coupons' + '/list/' + this.current_list_id]);
    } else {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug + '/coupons']);
    }
  }

  openRecipesPage() {
    if (this.is_list_view) {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug + '/recipes' + '/list/' + this.current_list_id]);
    } else {
      this.router.navigate(['/' + this.store_name_slug + '/' + this.store_name_slug + '/recipes']);
    }
  }

  normalView() {
    localStorage.setItem("view", "CircularView")
    window.location.reload()
  }

  largeView() {
    localStorage.setItem("view", "normalView")
    window.location.reload()
  }

  listView() {
    localStorage.setItem("view", "listView")
    window.location.reload()
  }

}
